import { useParams } from "react-router-dom";
import SimpleRegister from "./Simple";
import DiagnosisRegister from "./Diagnosis";
import PeriodicRegister from "./Periodic";
import CertificationRegister from "./Certification";

export default function QuestionnaireRegister() {
  const { id: type } = useParams();
  return type === "simple" ? (
    <SimpleRegister />
  ) : type === "diagnosis" ? (
    <DiagnosisRegister />
  ) : type === "periodic" ? (
    <PeriodicRegister />
  ) : (
    <CertificationRegister />
  );
}
